import * as React from "react";

function SvgDataLakes(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M118.404 21.773s-6.861 21.405-47.188 24.025c-27.98 1.815-62.256-5-62.256-24.025C8.96-2.8 40.72-5.837 67.624 8.958c22.133 12.17 50.78 12.815 50.78 12.815"
          fill="#2642CC"
        />
        <path
          d="M63.692 106.957s54.733 0 54.733-.635V10.533C99.664-8.898 85.259 8.96 61.074 23.36c-23.32 13.886-42.702 12.59-52.083-.363l-.01 83.325s24.49.635 54.711.635"
          fill="#598AE3"
        />
        <path
          d="M118.404 105.98c0 12.017-24.5 21.76-54.722 21.76-30.22 0-54.722-9.743-54.722-21.76 0-12.018 24.501-21.76 54.722-21.76 30.222 0 54.722 9.742 54.722 21.76"
          fill="#598AE3"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgDataLakes);
